/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Container,
  Grid,
  Card,
  CardContent,
  CardHeader,
  Button,
  Divider,
} from "@material-ui/core";

// Karsten
import HeaderClientes from "components/_refactor/headers/clients";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import StructureFields from "components/_refactor/fields/structure";
import AutoCompleteField from "components/_refactor/fields/autocomplete";

import componentStyles from "assets/theme/views/admin/react-bs-table";
import Api from "lib/api/httpRequestHelper";
import ClearButton from "components/_refactor/button/clear";
import LoadingData from "components/Loading/LoadingData";
import useLogs from "hooks/logs";

import TableMonitorPedidosPrateleiraInfinita from "./table/TableMonitorPedidosPrateleiraInfinita";
import { IsMobile, IsMobile900 } from "utils/is-mobile";
import InputText from "components/_refactor/text/input";

const useStyles = makeStyles(componentStyles);
const useCustomStyles = makeStyles({
  fields: {
    display: "flex",
    flexDirection: "column",
    width: 300,
    marginTop: "1rem",
  },
  option: {
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    wordBreak: "keep-all",
  },
  paper: {
    width: "max-content !important",
    minWidth: "100%",
  },
  popper: {
    maxWidth: "calc(100% - 60px - 1.5rem)",
    width: "max-content",
  },
});

const statusIntegrationOptions = [
  {
    value: "Erro",
    name: "Erro",
    id: 1,
  },
  {
    value: "Sucesso",
    name: "Sucesso",
    id: 2,
  },
  {
    value: "Todos",
    name: "Todos",
    id: 3,
  },
];

const statusPedido = [
  {
    value: "Aprovado",
    name: "Aprovado",
    id: 1,
  },
  {
    value: "Cancelado",
    name: "Cancelado",
    id: 2,
  },
  {
    value: "Entregue",
    name: "Entregue",
    id: 3,
  },
  {
    value: "Registrado",
    name: "Registrado",
    id: 4,
  },
  {
    value: "Transporte",
    name: "Transporte",
    id: 5,
  },
];

function DashboardMonitorPedidosPrateleiraInfinita() {
  const snackbar = useSnackbar();
  const { setLocalStorageActions } = useLogs();
  const classes = { ...useStyles(), ...useCustomStyles() };
  const { setLocalStorageApiProblem } = useLogs();

  const [searching, setSearching] = useState(false);
  const [clearFilters, setClearFilters] = useState(false);
  const [cancelLoading, setCancelLoading] = useState(false);

  const [structureFilters, setStructureFilters] = useState({});
  const [structureLoading, setStructureLoading] = useState([]);
  const [statusOrder, setStatusOrder] = useState("");
  const [orderNumber, setOrderNumber] = useState("");
  const [statusIntegracao, setStatusIntegracao] = useState("Todos");
  const [ordersList, setOrdersList] = useState(null);

  const [totalRegisters, setTotalRegisters] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentSizePerPage, setCurrentSizePerPage] = useState(25);

  const isMobile900 = IsMobile900();
  const isMobile = IsMobile();

  const itemXS = isMobile ? 12 : isMobile900 ? 6 : 3;

  const searchData = async ({ page = 1, sizePerPage = 25 }) => {
    setCancelLoading(false);
    setSearching(true);
    setLocalStorageActions({
      nomeTela: "Dashboard Monitor de Pedidos Prateleira Infinita",
      idMenu: "151",
      acao: "Clicou para Pesquisar",
    });

    await Api.get(
      "list-integration-log",
      "seta",
      `?page=${page - 1}` +
        `&pageSize=${sizePerPage ? sizePerPage : 25}` +
        `&idPedido=${orderNumber}` +
        `&statusIntegracao=${
          statusIntegracao === "Todos" ? "" : statusIntegracao
        }` +
        `&statusPedido=${statusOrder}` +
        `&idPessoaLoja=${
          structureFilters?.idLoja ? structureFilters?.idLoja : ""
        }`,
      true
    )
      .then((res) => {
        setOrdersList(res?.Result?.Pedidos || []);
        setTotalRegisters(res?.Result?.TotalRegistros);
        setCurrentPage(page);
        setCurrentSizePerPage(sizePerPage);
      })
      .catch((error) => {
        console.log(error);
        snackbar.showMessage(error, {
          severity: "error",
        });
        setLocalStorageApiProblem({
          idMenuAccess: "151",
          screen: "Monitor de Pedidos Prateleira Infinita",
          problem: `Erro na chamada do endpoint list-integration-log - ${error}`,
        });
      })
      .finally(() => setSearching(false));
  };

  const handleClearFilters = () => {
    setClearFilters(true);
    setSearching(true);
    setStructureLoading(true);

    setStatusIntegracao("Todos");
    setStatusOrder("");
    setOrderNumber("");
    setSearching(false);
    setStructureLoading(false);
  };

  const handleStopSearching = () => {
    setCancelLoading(true);
    setSearching(false);
    setOrdersList(null);
  };

  useEffect(() => {
    if (structureFilters?.idLoja === "") {
      setClearFilters(false);
    }
  }, [structureFilters]);

  return (
    <>
      <HeaderClientes
        section="Monitor de Pedidos Prateleira Infinita"
        subsection="Dashboard"
      />
      <Container style={{ marginTop: "-4.5rem" }} maxWidth={false}>
        <Grid container>
          <Grid item xs={12}>
            <Card classes={{ root: classes.cardRoot }}>
              <CardHeader
                className={classes.cardHeader}
                title="Filtros"
                titleTypographyProps={{
                  component: Box,
                  marginBottom: "0!important",
                  variant: "h3",
                }}
              ></CardHeader>

              <CardContent>
                <Grid container spacing={2} alignItems="center">
                  <StructureFields
                    clearFilters={clearFilters}
                    onStructureFieldsChange={setStructureFilters}
                    disableAll={searching}
                    onStructureFieldsLoad={setStructureLoading}
                    hideFields={[
                      "channel",
                      "brand",
                      "representative",
                      "economicGroup",
                    ]}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Divider style={{ margin: "1rem 0" }} />
                </Grid>

                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={itemXS}>
                    <InputText
                      label="Nº Pedido"
                      disabled={searching}
                      value={orderNumber}
                      onChange={(e) => {
                        setOrderNumber(e.target.value.slice(0, 20));
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          searchData({
                            page: 1,
                            sizePerPage: currentSizePerPage,
                          });
                        }
                      }}
                    />
                  </Grid>
                  <Grid item xs={itemXS}>
                    <AutoCompleteField
                      optionLabelKey="name"
                      optionIdKey="value"
                      options={statusPedido}
                      label="Status do Pedido"
                      value={statusOrder}
                      onChange={setStatusOrder}
                      disabled={searching}
                    />
                  </Grid>
                  <Grid item xs={itemXS}>
                    <AutoCompleteField
                      optionLabelKey="name"
                      optionIdKey="value"
                      options={statusIntegrationOptions}
                      label="Status da Integração"
                      value={statusIntegracao}
                      onChange={setStatusIntegracao}
                      disabled={searching}
                    />
                  </Grid>
                </Grid>

                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={isMobile ? 12 : isMobile900 && 6}>
                    <Button
                      style={
                        isMobile || isMobile900
                          ? {
                              width: "100%",
                              marginBottom: "0.75rem",
                              marginTop: "0.75rem",
                            }
                          : { marginBottom: "0rem" }
                      }
                      variant="contained"
                      onClick={searchData}
                      disabled={searching || structureLoading.length > 0}
                    >
                      {searching ? "Pesquisando..." : "Pesquisar"}
                    </Button>
                  </Grid>
                  <Grid
                    item
                    xs={isMobile ? 12 : isMobile900 && 6}
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <ClearButton
                      fullWidth={true}
                      disable={searching}
                      onClick={() => handleClearFilters()}
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
            <LoadingData
              searching={searching}
              onClick={() => handleStopSearching()}
              classes={classes.root}
              label="Buscando dados..."
            />
          </Grid>
        </Grid>
        {!searching && ordersList && !cancelLoading ? (
          <TableMonitorPedidosPrateleiraInfinita
            dataTable={ordersList}
            totalRegistros={totalRegisters}
            currentPage={currentPage}
            currentSizePerPage={currentSizePerPage}
            handleSearch={searchData}
            searching={searching}
          />
        ) : null}
      </Container>
    </>
  );
}

export default DashboardMonitorPedidosPrateleiraInfinita;
